import axios from 'axios'
import cookies from 'vue-cookies'
import SocketioChatService from '~/services/socketio/socketio.chat.service.js'

export default {
  namespaced: true,
  state: {
    offerAgreementGrid: [],
    offerAgreementShow: {},
    offerAgreementLast: {},
    offerAgreementNotAccepted: false,
    offerAgreementUserShow: {},
    pageData: null,
  },
  mutations: {
    setOfferAgreementGrid(state, payload) {
      state.offerAgreementGrid = payload
    },
    setOfferAgreementShow(state, payload) {
      state.offerAgreementShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setOfferAgreementLast(state, payload) {
      state.offerAgreementLast = payload
    },
    setOfferAgreementNotAccepted(state, payload) {
      state.offerAgreementNotAccepted = payload
    },
    setOfferAgreementUserShow(state, payload) {
      state.offerAgreementUserShow = payload
    },
  },
  getters: {
    offerAgreementGrid: (state) => state.offerAgreementGrid,
    offerAgreementShow: (state) => state.offerAgreementShow,
    offerAgreementLast: (state) => state.offerAgreementLast,
    offerAgreementNotAccepted: (state) => state.offerAgreementNotAccepted,
    offerAgreementUserShow: (state) => {
      try {
        var o = JSON.parse(state.offerAgreementUserShow)
        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) {}

      return {}
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onOfferAgreementGrid({ commit, rootState }, { limit, page }) {
      commit('setLoadingAnimation', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/common/agreement/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&order[]=id:desc',
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setOfferAgreementGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onOfferAgreementLast({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/common/agreement/grid?limit=1' +
            '&page=1' +
            '&order[]=id:desc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setOfferAgreementLast', resp.data.data[0])
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onOfferAgreementShow({ commit, rootState }, id) {
      commit('setLoadingAnimation', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/agreement/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setOfferAgreementShow', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onOfferAgreementCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/agreement',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onOfferAgreementUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/agreement',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onOfferAgreementPublishLast({ rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/agreement/publish',
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onOfferAgreementDeleteLast({ rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/agreement',
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    onOfferAgreementUserShow({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/common/agreement',
          method: 'GET',
        })
          .then((resp) => {
            commit('setOfferAgreementUserShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onOfferAgreementUserSign({ dispatch, commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/common/agreement',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            if (data.confirmed === 1) {
              commit('setOfferAgreementNotAccepted', false)
              dispatch('user/getUser', null, { root: true })
              SocketioChatService.setupSocketConnection()
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onOfferAgreementUserHistory({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/common/agreement/history/' + id + '?order[]=id:desc',
          method: 'GET',
        })
          .then((resp) => {
            // commit('setOfferAgreementUserHistory', resp.data.data)
            resolve(resp.data.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
